module.exports = __webpack_public_path__ + "static/astronaut-f127bf9a19185c505cde14fdf92fe8cb.svg";